var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#FFEBEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 8.75C11.7 8.75 11.5292 8.76667 11.3584 8.79583L5.42085 6.25L5.41669 9.16667L9.16669 10L5.41669 10.8333L5.42085 13.75L8.78335 12.3083C8.99585 13.8292 10.2959 15 11.875 15C13.6 15 15 13.6 15 11.875C15 10.15 13.6 8.75 11.875 8.75ZM11.875 14.1667C10.6125 14.1667 9.58335 13.1375 9.58335 11.875C9.58335 10.6125 10.6125 9.58333 11.875 9.58333C13.1375 9.58333 14.1667 10.6125 14.1667 11.875C14.1667 13.1375 13.1375 14.1667 11.875 14.1667Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6125 10.8458L11.875 11.5792L11.1375 10.8458L10.8458 11.1375L11.5792 11.875L10.8458 12.6125L11.1375 12.9042L11.875 12.1708L12.6125 12.9042L12.9042 12.6125L12.1708 11.875L12.9042 11.1375L12.6125 10.8458Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelReport);
export default __webpack_public_path__ + "static/media/CancelReport.d670c339.svg";
export { ForwardRef as ReactComponent };